import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ActualizacionProrrogaService = async (values) => {
    try {
        return await instance.Backend.post("/Hallazgo/ProrrogaActualizacion",values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { ActualizacionProrrogaService };